<template>
  <footer class="py-3">
    <b-container>
      <div class="d-flex my-flex">
        <span class="text-left">&copy; Copyright 2008-2020 Avishkaar.cc </span>
        <span class="d-flex my-flex-inner text-left">
          <a href="https://www.avishkaar.cc/privacy-policy" target="_blank"
            >Privacy Policy</a
          >
          <a href="https://www.avishkaar.cc/terms-conditions" target="_blank"
            >Terms of Use</a
          >
          <a
            href="https://www.avishkaar.cc/refunds-cancellations"
            target="_blank"
            >Shipping &amp; Cancellations</a
          >
        </span>
      </div>
    </b-container>
    <div class='footer-bottom-spacer w-100'></div>
  </footer>
</template>

<script>
export default {
  name: "FooterTnc",
};
</script>

<style scoped>
*,
a {
  text-decoration: none;
  color: #fff;
  font-size: 12px;
}
a:hover {
  color: #fff;
}
footer {
  background-color: #003455;
  /* min-height: 80px; */
}
.my-flex {
  height: 60px;

  justify-content: space-between;
  align-items: center;
}
.my-flex-inner {
  min-width: 40%;
  justify-content: space-around;
}
.my-flex-inner > a {
  padding-right: 10px;
}
.my-flex-inner > a:last-child {
  padding-right: 0;
}
@media screen and (max-width: 576px) {
  /* footer {
  } */
  .my-flex {
    flex-direction: column;
    align-items: stretch;
  }
  .my-flex-inner {
    width: 100%;
    justify-content: space-between;
  }
}
@media screen and (max-width: 300px) {
  .my-flex {
    height: 80px;
  }
}

/* bottom spacer */
.footer-bottom-spacer {
  display: none;
}
@media screen and (max-width: 576px) {
.footer-bottom-spacer {
  display: block;
  height: 80px;
}
}
</style>
